import React from 'react';
import { MaskedTextField } from '../ui/MaskedTextField';

type VerificationInputBlockProps = {
  title: string;
  subtitle: string;
  value: string;
  onChange: (value: string) => void;
  maxLength: number;
  onResend?: () => void;
  isResending?: boolean;
};

export const VerificationInputBlock: React.FC<VerificationInputBlockProps> = ({
  title,
  subtitle,
  value,
  onChange,
  maxLength,
  onResend,
  isResending = false,
}) => {
  const mask = '_'.repeat(maxLength);

  return (
    <div className="w-full flex flex-col items-center gap-3">
      <div className="self-stretch flex flex-col items-center gap-1 px-[70px]">
        <div className="self-stretch text-center text-black text-[14px] font-avenir font-medium break-words">
          {title}
        </div>
        <div className="text-center text-[#4A5565] text-[12px] font-avenir font-normal leading-5 break-words">
          {subtitle}
        </div>
      </div>

      <div className="flex flex-col items-start gap-2">
        <MaskedTextField value={value} onChange={onChange} mask={mask} />
      </div>

      <div className="self-stretch flex flex-col items-start gap-1">
        <div className="self-stretch text-center">
          <span className="text-black text-[12px] font-avenir font-normal leading-5 break-words">
            Didn't receive the code?{' '}
          </span>
          {onResend && (
            <span
              onClick={isResending ? undefined : onResend}
              className={`text-black text-[12px] font-avenir font-extrabold underline leading-5 ${
                isResending ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'
              }`}
            >
              {isResending ? 'Sending...' : 'Resend'}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};
